import clsx from 'clsx';

/**
 * Skeleton - Base skeleton loading bileşeni
 * Tailwind ile custom shimmer animasyonu
 * 
 * @param {string} variant - 'text' | 'circular' | 'rectangular' | 'rounded'
 * @param {string} width - Genişlik (Tailwind class veya inline)
 * @param {string} height - Yükseklik (Tailwind class veya inline)
 * @param {string} className - Ek CSS sınıfları
 * @param {boolean} animate - Animasyon aktif mi
 */
export function Skeleton({
    variant = 'text',
    width,
    height,
    className,
    animate = true,
    style,
}) {
    const variants = {
        text: 'h-4 rounded',
        circular: 'rounded-full',
        rectangular: 'rounded-none',
        rounded: 'rounded-lg',
    };

    return (
        <div
            className={clsx(
                'bg-neutral-200 dark:bg-neutral-700',
                animate && 'animate-pulse',
                variants[variant],
                width,
                height,
                className
            )}
            style={style}
        />
    );
}

/**
 * SkeletonText - Metin satırları için skeleton
 */
export function SkeletonText({ lines = 3, className }) {
    return (
        <div className={clsx('space-y-2', className)}>
            {Array.from({ length: lines }).map((_, i) => (
                <Skeleton
                    key={i}
                    variant="text"
                    className={clsx(
                        'h-4',
                        i === lines - 1 ? 'w-3/4' : 'w-full' // Son satır kısa
                    )}
                />
            ))}
        </div>
    );
}

/**
 * SkeletonAvatar - Avatar için skeleton
 */
export function SkeletonAvatar({ size = 'md', className }) {
    const sizes = {
        sm: 'w-8 h-8',
        md: 'w-10 h-10',
        lg: 'w-12 h-12',
        xl: 'w-16 h-16',
    };

    return (
        <Skeleton
            variant="circular"
            className={clsx(sizes[size], className)}
        />
    );
}

/**
 * SkeletonButton - Button placeholder
 */
export function SkeletonButton({ size = 'md', className }) {
    const sizes = {
        sm: 'h-8 w-20',
        md: 'h-10 w-28',
        lg: 'h-12 w-36',
    };

    return (
        <Skeleton
            variant="rounded"
            className={clsx(sizes[size], className)}
        />
    );
}

export default Skeleton;
